// ============================================
// 檔案名稱: adminConfig.js
// 路徑: src/config/adminConfig.js
// 用途: 管理員帳號設定
// ============================================

export const ADMIN_UID = "gFwOsNadC9MoPzPdrn85H09AtVt2";
